import React from "react";
import { Navigate, useParams } from "react-router-dom";

export { WhatsAppCampaignReport } from "./WhatsAppPlatform";

/** /apps/:appId/whatsapp → inbox (platform home) */
export function WhatsAppIndexRedirect() {
  const { appId } = useParams();
  return <Navigate to={`/apps/${appId}/whatsapp/inbox`} replace />;
}

/** Legacy: /apps/:appId/settings/whatsapp → connection */
export function WhatsAppLegacyRedirect() {
  const { appId } = useParams();
  return <Navigate to={`/apps/${appId}/whatsapp/connection`} replace />;
}
